import createIcon from '../../createIcon';

/**
 * @component @name NoteAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEgxNC44MkMxNC40IDIuODQgMTMuMyAyIDEyIDJDMTAuNyAyIDkuNiAyLjg0IDkuMTggNEg1QzMuOSA0IDMgNC45IDMgNlYyMEMzIDIxLjEgMy45IDIyIDUgMjJIMTlDMjAuMSAyMiAyMSAyMS4xIDIxIDIwVjZDMjEgNC45IDIwLjEgNCAxOSA0Wk0xMiAzLjc1QzEyLjQxIDMuNzUgMTIuNzUgNC4wOSAxMi43NSA0LjVDMTIuNzUgNC45MSAxMi40MSA1LjI1IDEyIDUuMjVDMTEuNTkgNS4yNSAxMS4yNSA0LjkxIDExLjI1IDQuNUMxMS4yNSA0LjA5IDExLjU5IDMuNzUgMTIgMy43NVpNOS4xIDE4SDdWMTUuODZMMTIuOTYgOS45TDE1LjA4IDEyLjAyTDkuMSAxOFpNMTYuODUgMTAuMjdMMTUuNzkgMTEuMzNMMTMuNjcgOS4yMUwxNC43MyA4LjE1QzE0LjkzIDcuOTUgMTUuMjQgNy45NSAxNS40NCA4LjE1TDE2Ljg1IDkuNTZDMTcuMDUgOS43NiAxNy4wNSAxMC4wNyAxNi44NSAxMC4yN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoteAlt = createIcon('NoteAlt', [
  [
    'path',
    {
      d: 'M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM9.1 18H7V15.86L12.96 9.9L15.08 12.02L9.1 18ZM16.85 10.27L15.79 11.33L13.67 9.21L14.73 8.15C14.93 7.95 15.24 7.95 15.44 8.15L16.85 9.56C17.05 9.76 17.05 10.07 16.85 10.27Z',
      key: '1thf5q',
    },
  ],
]);

export default NoteAlt;
